import React from 'react';
import $ from 'jquery';
import { I18n, Trans } from 'react-i18next';



export class Logo extends React.Component {


  toggleNavbar(e) {
    //alert(e);
     $('#header-navbar').css('background','url(images/menu-bg.png) no-repeat center');

    //hide brand logo
    $('#header-navbar .navbar-brand.logo').css('display','none');
    $('#header-navbar .navbar-brand.mobile-logo').css('display','none');
    

    //menu text hide/show
    $("#home-text").addClass("hide");
    $("#menu-text").addClass("show");

    $(".navbar-right").addClass("hide");
    
    $('#head-navbar span').addClass('circle-display');
    $('#head-navbar span').removeClass('active-circle');

    $('#menu-style').addClass('menu-text-style');
    $('#menu-style').removeClass('active-link');
    
    $('#toggle-img').addClass('navbar-toggle-alt-img');
    $('#toggle-img').removeClass('navbar-toggle-img');
    
    $('.btm-logo').toggleClass('show');
  }

  toggleNavbarShow(e) {
     $('#header-navbar').css('background','none');
    // $('#header-navbar .navbar-brand.logo').css('display','none');
    // $('#header-navbar .navbar-brand.mobile-logo').css('display','block');
    $("#home-text").removeClass("hide");
    $("#menu-text").removeClass("show");
    $('#head-navbar span').removeClass('circle-display');
    $('#head-navbar span').addClass('active-circle');
    $('#toggle-img').removeClass('navbar-toggle-alt-img');
     $('#toggle-img').addClass('navbar-toggle-img');
    
    var $theWindowSize = $(document).width();
    if($theWindowSize <= 480)
        {
            $('#header-navbar .navbar-brand.mobile-logo').css('display','block');

        }
        else if($theWindowSize > 480 && $theWindowSize <= 767){
            $('#header-navbar .navbar-brand.logo').css('display','block');
            $('#header-navbar .navbar-brand.mobile-logo').css('display','none');
        }
  }
 
  render() {
    return (
      <I18n ns="translations">
        {
          (t, { i18n }) => (
  <div className="navbar-header">
      <span id="home-text" >
        <img src="../../images/ic_burger.png" className="navbar-toggle navbar-toggle-img" data-toggle="collapse" onClick={this.toggleNavbar} data-target="#myNavbar"/>
        <span className="active-link"><small>{t("about")}</small> </span>
      </span>
      
      <span id="menu-text" className="hide">
        <img id="toggle-img" onClick={this.toggleNavbarShow} src="../../images/menu-icon.png" className="navbar-toggle navbar-toggle-img" data-toggle="collapse" data-target="#myNavbar"/>      
        <span id="menu-style" className="active-link"><small>Menu</small> </span>
      </span>
        <a className="navbar-brand logo" href="#"><img className="navbar-brand-img" src="../../images/logo.png"/></a>
        <a className="navbar-brand mobile-logo" href="#"><img className="navbar-brand-img" src="../../images/320-logo-new.png"/></a>
   </div>
       )
          }
      </I18n> 
   );
  }
}


// WEBPACK FOOTER //
// ./src/components/Propos/Nav/Logo.js